export const INTERACTION_COLUMNS_SETS_LIST_OPEN = 'columns_sets_list_open';
export const INTERACTION_ISSUE_CARD_OPEN = 'issue_card_open';
export const INTERACTION_ISSUES_CATEGORY_OPEN = 'issues_screen_open';
export const INTERACTION_PAGE_DETAIL_OPEN = 'page_detail_open';
export const INTERACTION_PAGES_OVERVIEW_OPEN = 'pages_overview_open';
export const INTERACTION_PRIORITIZE_BUTTON_CLICK = 'prioritize_button_click';
export const INTERACTION_TEAM_PROFILE_OPEN = 'team_profile_open';
export const INTERACTION_WEBSITE_DETAIL_OPEN = 'website_detail_open';
